import * as Yup from 'yup';

const feedbackBlockSchema = Yup.object().shape({
  ratingEnabled: Yup.bool().default(true),
  headline: Yup.string().label('Headline').required().default(''),
  subtitle: Yup.string().label('Subtitle').required().default(''),
});

export default feedbackBlockSchema;
